module.exports = __webpack_public_path__ + "static/media/sports_19.2e471dcf.jpg";